import { render, staticRenderFns } from "./modalEditCompany.vue?vue&type=template&id=58d2456e&"
import script from "./modalEditCompany.vue?vue&type=script&lang=js&"
export * from "./modalEditCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports